import { http, isHttpError } from '../http';

export type RevokePublicRetrievalResult =
	| { status: 'ok'; publicRevokedAt: string | null }
	// The backend refuses to re-enable, and refuses a second revoke of an
	// already-withdrawn document. Either way the row is already withdrawn.
	| { status: 'conflict' }
	| { status: 'forbidden' }
	| { status: 'error' };

// Withdrawing public retrieval is irreversible: the public copy of the signed
// PDF is deleted and cannot be restored (note #6, §8.6). Callers must confirm
// with the user before calling this.
export async function revokePublicRetrieval(
	documentUlid: string,
): Promise<RevokePublicRetrievalResult> {
	try {
		const response = await http.patch<{
			public_retrieval?: boolean;
			public_revoked_at?: string | null;
		}>(
			`documents/${encodeURIComponent(documentUlid)}/public-retrieval`,
			{ enabled: false },
			// A 403 here means "not your document", not "session expired", so
			// it must surface as a message rather than log the owner out.
			true,
		);

		return {
			status: 'ok',
			publicRevokedAt: response?.public_revoked_at ?? null,
		};
	} catch (error) {
		if (isHttpError(error)) {
			if (error.status === 409) return { status: 'conflict' };
			if (error.status === 403) return { status: 'forbidden' };
		}
		return { status: 'error' };
	}
}
